module.exports = __webpack_public_path__ + "img/Ecology_-_BN-t-23576-009.bcd8da45.jpg";